module.exports = __webpack_public_path__ + "static/img/areaB_8.5f98758.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/areaB_8.png
// module id = 1280
// module chunks = 1